import type { MantineThemeComponents } from '@mantine/core'
import { Button, Drawer, Modal, Radio, Select } from '@mantine/core'
import { IconX } from '@tabler/icons-react'

export const mantineComponents: MantineThemeComponents = {
  Button: Button.extend({
    defaultProps: {
      variant: 'outline',
      loaderProps: {
        type: 'dots',
      },
    },
    styles: theme => ({
      root: {
        borderRadius: theme.radius.xl,
        borderWidth: '3px',
        fontWeight: 700,
      },
    }),
  }),

  Drawer: Drawer.extend({
    defaultProps: {
      closeButtonProps: {
        icon: <IconX size={40} stroke={1.5} />,
      },
    },
  }),

  Modal: Modal.extend({
    defaultProps: {
      centered: true,
      withCloseButton: false,
      overlayProps: {
        backgroundOpacity: 0.55,
        blur: 3,
      },
    },
    styles: () => ({
      content: {
        padding: 0,
      },
      header: {
        padding: 0,
        borderBottom: 0,
        position: 'sticky',
        top: 0,
        zIndex: 10,
        minHeight: 'unset',
        height: 'auto',
      },
      inner: {
        padding: 0,
      },
      close: {
        top: '12px',
        right: '12px',
      },
    }),
  }),

  Radio: Radio.extend({
    defaultProps: {
      variant: 'outline',
      color: 'gray.9',
      iconColor: 'gray.9',

    },
    styles: theme => ({
      radio: {
        border: `2px solid ${theme.colors.gray[9]}`,
      },
      icon: {
        color: theme.colors.gray[9],
      },
    }),
  }),

  Select: Select.extend({
    defaultProps: {
      variant: 'filled',
      size: 'lg',
    },
    styles: () => ({
      input: {
        fontSize: '15px',
      },
      option: {
        fontSize: '15px',
      },
    }),
  }),
}
